export class MenuItemConstants{

    static readonly HOME:                string = 'Home';
    static readonly ADMIN:               string = 'Admin';
    /* SALES */
    static readonly SALES:               string = 'Sales';
    static readonly SALES_REPORTS:       string = 'Sales Reports';
    static readonly NEW_SALE:            string = 'New Sale';

    /* DOCUMENTS */
    static readonly DOCUMENTS:           string = 'Documents';
    static readonly NEW_DOCUMENT:        string = 'New Document';
    
    static readonly READER_CHILD:        string = 'Reader Child';
    static readonly READER:              string = 'Reader';
    static readonly CONTRIBUTOR:         string = 'Contributor';
}

export class ApplicationTitleConstants{

    static readonly FULL_TITLE:         string = 'Orona Chat';
    static readonly SHORT_TITLE:        string = 'Orona';
}